/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { GoAltamira, GoDarMas, GoProseguros, GoQualitas, GoVCard, LogoQR } from '../../../assets/img';
import { BackIcon, RightIcon } from '../../../assets/icons';
import { GoApp, GoWeb } from '../../../assets/img';
import { GeneralService } from '../../../services';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const Referrals = () => {
  const { code } = useParams();
  const { androidLink, existCode, isIOS, vcardLink, webLink } = useFetch();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className="w-full h-screen p-4 bg-[#F2F2F2] overflow-auto">
      <Link to="/" className="flex items-center">
        <img className="w-6 h-6 object-contain invert left-4 top-4" src={BackIcon} alt="Volver" />
      </Link>

      <div className="w-80 md:w-96 bg-white border border-gray6 rounded-3xl overflow-hidden m-auto mt-20">
        <div className="w-full bg-blue py-4">
          <img className="w-28 object-contain mx-auto brightness-0 invert" src={LogoQR} alt="logo" />
        </div>

        <div className="p-4 flex flex-col gap-4">
          <p className="text-center font-semibold text-gray mb-2">
            Puedes visitar nuestra Web o descargar nuestra App en tu dispositivo
          </p>

          <Button
            label="Regístrate y Compra"
            icon={GoWeb}
            onClick={() => {
              dispatch({
                type: 'SET_REFERRAL_CODE',
                payload: code
              });
              history.replace(webLink);
            }}
          />
          {!isIOS && (
            <AnchorButton
              label="Descargar nuestra App"
              icon={GoApp}
              to={androidLink + '&referrer=referral_code%3D' + code }
            />
          )}
          {existCode && (
            <AnchorButton
              label="Descargar Contacto"
              icon={GoVCard}
              to={vcardLink}
            />
          )}

          {/* Muestra contenido adicional para un referido en específico en producción */}
          {code === 'b6e2c5a4-2de3-4cc5-a97b-51b8f9d5c563' && (
            <>
              <AnchorButton
                label="Web Seguros Altamira"
                icon={GoAltamira}
                to="https://www.segurosaltamira.com/"
              />
              <AnchorButton
                label="Web Seguros Qualitas"
                icon={GoQualitas}
                to="https://www.seguros-qualitas.com/"
              />
              <AnchorButton
                label="Web Proseguros"
                icon={GoProseguros}
                to="https://www.proseguros.com.ve/"
              />
              <AnchorButton
                label="Web Darsalud"
                icon={GoDarMas}
                to="https://www.darsalud.com.ve/"
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

const Button = ({ label, icon, onClick }) => (
  <button
    className="bg-[#F2F2F2] w-full flex items-center gap-4 p-2 rounded-2xl border border-gray6"
    onClick={onClick}
  >
    <img className="w-10 h-10 md:w-14 md:h-14 object-contain" src={icon} alt="Icono" />

    <p className="flex-1 text-left font-semibold">{label}</p>

    <div className="w-8 h-8 bg-blue flex items-center justify-center rounded-full">
      <img className="w-4 h-4 object-contain" src={RightIcon} alt="Ir" />
    </div>
  </button>
);

const AnchorButton = ({ label, icon, to }) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    className="bg-[#F2F2F2] w-full flex items-center gap-4 p-2 rounded-2xl border border-gray6"
    href={to}
  >
    <img className="w-10 h-10 md:w-14 md:h-14 object-contain" src={icon} alt="Icono" />

    <p className="flex-1 text-left font-semibold">{label}</p>

    <div className="w-8 h-8 bg-blue flex items-center justify-center rounded-full">
      <img className="w-4 h-4 object-contain" src={RightIcon} alt="Ir" />
    </div>
  </a>
);

const useFetch = () => {
  const { code } = useParams();
  const [existCode, setExistCode] = React.useState(false);

  const isWindows = navigator.userAgent.indexOf('Windows') !== -1;
  const isMac = navigator.userAgent.indexOf('Macintosh') !== -1;
  const isIOS = navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1;
  const isAndroid = navigator.userAgent.indexOf('Android') !== -1;

  const webLink = `/?referral_code=${code}`;
  const androidLink = 'https://play.google.com/store/apps/details?id=com.limonbyte.seguros&hl=es_VE&gl=US';
  const iosLink = '';
  const vcardLink = process.env.REACT_APP_BASE_API + 'general/referral/vcard/' + code;

  useEffect(() => {
    GeneralService.saveIP(code)
      .then(() => setExistCode(true))
      .catch(console.log);
  }, []);

  return {
    androidLink,
    existCode,
    iosLink,
    isAndroid,
    isIOS,
    isMac,
    isWindows,
    vcardLink,
    webLink,
  }
}

export default Referrals;